import {deepchecker} from "./deepchecker.js";

export function FlagChecker(potential){
  let failed="Not the flag";
  if ((potential.length ^ 85) == 123){
    return deepchecker(potential);
  } else {
    return failed;
  }
}
